import { render, staticRenderFns } from "./DialogsPrompt.vue?vue&type=template&id=2a614d98&"
import script from "./DialogsPrompt.vue?vue&type=script&lang=js&"
export * from "./DialogsPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports